import React, { useState, useEffect } from "react";
import { Tabs, Row, Col, Button, Spin } from "antd";
import { isMobile } from "@/utils/public";
import Mxbssq from "./mxbssq";
import Mxbssh from "./mxbssh";

function Mxbs(props) {
  const { activeTab, types, models, tokens, userInfo } = props;
  const [tab, setTab] = useState("sq");
  const isMob = isMobile();
  const [spinning, setSpinning] = useState(false);
  const tabs = [
    {
      label: "模型部署申请",
      key: "sq",
      children:
        tab === "sq" ? <Mxbssq types={types} userInfo={userInfo} /> : undefined,
    },
  ];

  if (userInfo?.modelAudit) {
    tabs.push({
      label: "模型部署审核",
      key: "sh",
      children:
        tab === "sh" ? <Mxbssh types={types} userInfo={userInfo} /> : undefined,
    });
  }

  return (
    <div className={`${isMob ? "m-zdSearchContent" : "zdSearchContent"}`}>
      <div className="content">
        <Spin spinning={false}>
          <Tabs
            activeKey={tab}
            onChange={(activeKey) => {
              setTab(activeKey);
            }}
            style={{
              height: "100%",
            }}
            type="card"
            items={tabs}
            tabBarGutter={15}
          />
        </Spin>
      </div>
    </div>
  );
}

export default Mxbs;
